export default __webpack_public_path__ + "static/media/people.05f4fab3.svg";